import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../Images/logo.png";
import { products } from "../Data";
import callIcon from '../Images/call.png'
import mailIcon from '../Images/mail.png'


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const container = {
    hidden: { y: -80, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.08,
      },
    },
  };

  const navItem = {
    hidden: { y: -20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.4 },
    },
  };

  const sidebar = {
    hidden: { x: "-100%" },
    visible: { x: 0, transition: { duration: 0.4, ease: "easeOut" } },
    exit: { x: "100%", transition: { duration: 0.3 } },
  };

  const navLinks = [
  { name: "Home", path: "/" },
  { name: "About us", path: "/about-us" },
  { name: "Products", isDropdown: true },
  { name: "Applications", path: "/applications" },
  { name: "Calculator", path: "/calculator" },
];

  return (
    <>
      <motion.header
        className="main-header"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        <div className="container header-inner">

          {/* LOGO */}
          <div className="logo">
          <Link to='/'> <img src={logo} alt="VigoFlex Logo" /></Link> 
          </div>

          {/* DESKTOP NAV */}
          <div className="header-right">
          <nav className="nav">
  {navLinks.map((item, i) => (

    item.isDropdown ? (
      <div className="nav-item dropdown" key={i}>
        <motion.span className="dropdown-label" variants={navItem}>
          {item.name}
          <span className="chevron"></span>
        </motion.span>

        <div className="dropdown-menu">
          {products.map((prod, idx) => (
            <a key={idx} href={`/products${prod.path}`}>
              {prod.title}
            </a>
          ))}
        </div>
      </div>
    ) : (
      <motion.a key={i} href={item.path} variants={navItem}>
        {item.name}
      </motion.a>
    )

  ))}
</nav>

            <motion.a href="/contact-us" className="btn btn-primary" variants={navItem}>
              Contact Us
            </motion.a>
          </div>

          {/* HAMBURGER */}
         <div
  className={`hamburger ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(!menuOpen)}
>
  <span></span>
  <span></span>
  <span></span>
</div>

        </div>
      </motion.header>

      {/* SIDEBAR */}
      <AnimatePresence>
        {menuOpen && (
          <>
            {/* OVERLAY */}
            <motion.div
              className="sidebar-overlay"
              onClick={() => setMenuOpen(false)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />

            {/* SIDEBAR PANEL */}
           {/* SIDEBAR PANEL */}
<motion.div
  className="sidebar"
  variants={sidebar}
  initial="hidden"
  animate="visible"
  exit="exit"
>
  {/* BLOCK 1: TOP CONTENT */}
  <div className="sidebar-top-section">
    <div className="sidebar-header">
      <img src={logo} alt="VigoFlex Logo" className="sidebar-logo" />
    </div>

    <nav className="sidebar-links">

  <a href="/">Home</a>
  <a href="/about-us">About us</a>

  {/* PRODUCTS DROPDOWN */}
  <div className="mobile-dropdown">

    <div
      className="mobile-dropdown-head"
      onClick={() =>
        setOpenDropdown(openDropdown === "products" ? null : "products")
      }
    >
      Products
      <span className={`chevron ${openDropdown === "products" ? "open" : ""}`}></span>
    </div>

    <AnimatePresence>
      {openDropdown === "products" && (
        <motion.div
          className="mobile-dropdown-menu"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
        >
          {products.map((prod, idx) => (
            <a key={idx} href={`/products${prod.path}`} onClick={() => setMenuOpen(false)}>
              {prod.title}
            </a>
          ))}
        </motion.div>
      )}
    </AnimatePresence>

  </div>

  <a href="/applications">Applications</a>
  <a href="/calculator">Calculator</a>
  <motion.a href="/contact-us" className="btn btn-primary">
              Contact Us
            </motion.a>

</nav>
  </div>
  <div className="sidebar-footer">

  <a href="tel:+917016591400" className="sidebar-contact">
    <img src={callIcon} alt="Call Icon | VigoFlex" />
    <span>+91 7016591400</span>
  </a>

  <a href="mailto:info@vigoflex.in" className="sidebar-contact">
    <img src={mailIcon} alt="Mail Icon | VigoFlex" />
    <span>info@vigoflex.in</span>
  </a>

</div>
</motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;